import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';
import CSSModules from 'react-css-modules';
import styles from './debitCardForm.scss';
import CardNumberInput from './CardNumberInput';
import CvvInput from './CvvInput';
import ExpirationDateInput from './ExpirationDateInput';
import {CheckBoxInput} from "../Input";


class DebitCardForm extends React.Component {
  static propTypes = {
    name: PropTypes.string,
    cvvKey: PropTypes.string,
    onChange: PropTypes.func,
    hasCardholderName: PropTypes.bool,
    showSetDefaultPaymentMethodCheckbox : PropTypes.bool,
  };
  static defaultProps = {
    showSetDefaultPaymentMethodCheckbox : false,
  };

  constructor(props) {
    super(props);
    this.state = {
      cardNumber: '',
      expirationMonth: '',
      expirationYear: '',
      cvv: '',
      isDefaultPayment: false,
      cvvKey: this.props.cvvKey || 'cvvKey'
    };
  }

  handleOnChange = (value, name) => {
    let newState = {};
    if (name === 'expirationDate') {
      newState = {
        expirationMonth: '',
        expirationYear: '',
      };
      if (value) {
        newState = {...value};
      }
    }
    else {
      newState[name] = value;
    }
    this.setState(newState, () => {
      let debitCardDetails;
      debitCardDetails = this.setDebitCardDetails(this.validate());
      if (this.props.onChange) {
        this.props.onChange(debitCardDetails, this.props.name);
      }
    });
  };

  setDebitCardDetails = (isValid = false) => {
    let debitCardDetails;
    const { cardNumber, expirationMonth, expirationYear, cvv ,isDefaultPayment} = this.state;
    if(isValid) {
      if(this.props.showSetDefaultPaymentMethodCheckbox) { // in order not to break other usage for that component - if they dont need the isDefaultPayment value
        debitCardDetails = { debitCardDetails : { cardNumber, expirationMonth, expirationYear, cvv } ,isDefaultPayment : isDefaultPayment };
      } else {
        debitCardDetails = {  cardNumber, expirationMonth, expirationYear, cvv  };
      }
      return debitCardDetails;
    }
    if(this.props.showSetDefaultPaymentMethodCheckbox) {
      debitCardDetails = { debitCardDetails : undefined ,isDefaultPayment : isDefaultPayment };
    }
    return debitCardDetails;
  };

  validate = () => {
    const fields = ['cardNumber', 'expirationMonth', 'expirationYear', 'cvv'];
    for (const field of fields){
      if (!this.state[field]) {
        return false;
      }
    }
    return true;
  };

  onDefaultPayment = (isDefaultPayment) => {
    this.setState({isDefaultPayment}, this.handleOnChange);
  };

  componentDidUpdate(prevProps) {
    if (prevProps.cvvKey !== this.props.cvvKey) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState(() => ({cvvKey: this.props.cvvKey, cvv: ''}), () => {
        this.handleOnChange(this.state.cvv, 'cvv');
      });
    }
  }

  render() {
    const {showSetDefaultPaymentMethodCheckbox} = this.props;
    return (
      <div>
        <div styleName="partition">
          <CardNumberInput onChange={this.handleOnChange}
                           name="cardNumber" />
        </div>
        <div styleName="partition expirationAndCvv">
          <ExpirationDateInput onChange={this.handleOnChange}
                               name="expirationDate" />
          <CvvInput key={this.state.cvvKey || 'cvvKey'}
                    onChange={this.handleOnChange} name="cvv" />
        </div>
        {showSetDefaultPaymentMethodCheckbox &&
       <CheckBoxInput value={this.state.isDefaultPayment}
                      toolTipText={"If you check this box, we will automatically seek payment from the debit card you have selected above for your recurring payments in accordance with your AutoPay authorization. If you do not wish to use this debit card for AutoPay, do not check this box."}
                      onChange={this.onDefaultPayment}
                      checkBoxStatus={this.state.isDefaultPayment}
                      dataAt={`checkbox-set-default-payment`}
                      text={'Set as default payment method'}
                      name="defaultPayment"/>}
      </div>
    );
  }
}

export default injectIntl(CSSModules(styles, {allowMultiple: true})(DebitCardForm));



// WEBPACK FOOTER //
// ./src/components/common/debitCardForm/DebitCardForm.js